
// @ts-nocheck
import locale__Users_michael_Development_pingzapper_site_pz_site_locales_en_US_ts from "../locales/en-US.ts";
import locale__Users_michael_Development_pingzapper_site_pz_site_locales_zh_CN_ts from "../locales/zh-CN.ts";


export const localeCodes =  [
  "en",
  "zh-cn"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en-US.ts", load: () => Promise.resolve(locale__Users_michael_Development_pingzapper_site_pz_site_locales_en_US_ts), cache: true }],
  "zh-cn": [{ key: "../locales/zh-CN.ts", load: () => Promise.resolve(locale__Users_michael_Development_pingzapper_site_pz_site_locales_zh_CN_ts), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "files": [
        "locales/en-US.ts"
      ]
    },
    {
      "code": "zh-cn",
      "files": [
        "locales/zh-CN.ts"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "files": [
      {
        "path": "locales/en-US.ts"
      }
    ]
  },
  {
    "code": "zh-cn",
    "files": [
      {
        "path": "locales/zh-CN.ts"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
